import ChatDefinition from "@/chatbot-library/ChatDefinition"

class ChatText extends ChatDefinition {
  _promise = null
  _computedData = {}

  get _data() {
    if (this._promise) {
      return this._promise
    }

    if (typeof this.data === "object") {
      this._promise = Promise.resolve(this.data)
      this._computedData = this.data
      return this._promise
    }

    if (typeof this.data === "function") {
      this._promise = Promise
        .resolve(this.data())
        .then(data => {
          this._computedData = data
          return data
        })
      return this._promise
    }

    this._promise = Promise.resolve({})
    this._computedData = {}
    return this._promise
  }

  get asyncContent() {
    return this._data.then(data => data.content || "")
  }

  get asyncNext() {
    return this._data.then(data => data.next || null)
  }

  get asyncCallback() {
    return this._data.then(data => data.callback || null)
  }

  get asyncActions() {
    return this._data.then(data => data.actions || [])
  }

  get asyncConversationId() {
    return this._data.then(data => data.conversationId || null)
  }

  get content() {
    return this._computedData.content || ""
  }

  get next() {
    return this._computedData.next || null
  }

  get callback() {
    return this._computedData.callback || null
  }

  get actions() {
    return this._computedData.actions || []
  }

  get conversationId() {
    return this._computedData.conversationId || null
  }

  get delay() {
    return Number.isInteger(this.options.delay) ? this.options.delay : null
  }

  get isChatEnabled() {
    return this.options.isChatEnabled || false
  }
}

export default ChatText
